<template>
  <div>
    <PageHeader />

    <div class="container mx-auto pb-sf-base px-sf-sm md:px-sf-lg lg:px-sf-sm">
      <div class="mb-sf-lg">
        <h3 class="text-xl">Zuständig für den fachlichen Inhalt:</h3>
        <p>
          Allianz Beratungs- und Vertriebs-AG<br />
          Fachbereich Vertriebs- und Verkaufsprozesse
        </p>
      </div>

      <div class="mb-sf-lg">
        <h3 class="text-xl">
          Zuständig für den technischen Betrieb und Entwicklung:
        </h3>
        <p>
          Allianz ONE – Business Solutions GmbH<br />
          MedienServiceCenter
        </p>
      </div>

      <div>
        <h3 class="text-xl">Ihre Ansprechpartner erreichen Sie:</h3>
        <p>
          Montag bis Freitag<br />
          von 8 bis 12 Uhr und 13 bis 17 Uhr<br />
          unter der Rufnummer<br />
          <a href="tel:+495241500633">+49 5241-5006-33</a><br />
          oder per E-Mail an<br />
          <a href="mailto:allianz@arvato.com">allianz@arvato.com</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "~/components/Page/PageHeader.vue";
import { usePage } from "~/composables";
import { useCustomerStore } from "../modules/customer/stores/customer";

export default {
  name: "PortalResponsibility",
  components: { PageHeader },
  layout() {
    const customerStore = useCustomerStore();
    return customerStore.isLoggedIn ? "default" : "login";
  },
  setup() {
    const { pageTitle } = usePage();
    pageTitle.value = "Portalverantwortung";

    return {};
  },
  head() {
    return {
      title: "Portalverantwortung",
    };
  },
};
</script>

<style lang="scss" scoped></style>
